import { render } from "./edit-invoice.vue?vue&type=template&id=5ff93060"
import script from "./edit-invoice.vue?vue&type=script&lang=js"
export * from "./edit-invoice.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__